import { FieldValues, UseFormReturn } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import Button from '@mui/material/Button';

import { UseBoolHandlers } from '@barboxx/react-utils';

interface Props<T extends FieldValues> {
    formContext: UseFormReturn<T>;
    handleCancel: () => void;
    editable: boolean;
    editableActions: UseBoolHandlers;
}

export function EditButtons<T extends FieldValues>({
    formContext,
    handleCancel,
    editable,
    editableActions,
}: Props<T>) {
    return (
        <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            gap={2}
        >
            {editable ? (
                <>
                    <Button
                        onClick={handleCancel}
                        color="inherit"
                        variant="outlined"
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        color="primary"
                        variant="contained"
                        loading={formContext.formState.isSubmitting}
                        disabled={
                            !formContext.formState.isDirty ||
                            formContext.formState.isSubmitting
                        }
                    >
                        Save
                    </LoadingButton>
                </>
            ) : (
                <Button
                    color="primary"
                    variant="contained"
                    onClick={editableActions.on}
                >
                    Edit
                </Button>
            )}
        </Stack>
    );
}
